(function (){
    'use strict';

    angular
        .module('app')
        .directive('passwordValidate', passwordValidate);

    function passwordValidate() {
       return {
           restrict:'A',
           require:'ngModel',
           scope:{
               cod: '='
           },
           link:link,

       };

        // function link(scope, element, attrs, ctrl) {
        //     var firstPassword = '#' + attrs.pwCheck;
        //     elem.add(firstPassword).on('keyup', function () {
        //         scope.$apply(function () {
        //             var v = elem.val()===$(firstPassword).val();
        //             ctrl.$setValidity('pwmatch', v);
        //         });
        //     });
        //
        //
        // }
        function link(scope, element, attrs, ctrl) {


            var validator = function(value){
                var testValue = ctrl.$viewValue.length < 5 ? false : true;
                ctrl.$setValidity('passwordValidate', testValue);
                if(testValue) {
                    angular.element(element.parent().removeClass('has-error'));
                    angular.element(element.parent().find("span").remove());
                }else{
                    angular.element(element.parent().removeClass('has-error'));
                    angular.element(element.parent().find("span").remove());
                    angular.element(element.parent().addClass('has-error'));
                    angular.element(element.parent().append("<span class='help-block'>Please enter at least 5 characters</span>"));
                }
                return value;
            };

            ctrl.$parsers.unshift(validator);
            ctrl.$formatters.unshift(validator);


        }
    }
})();